// extracted by mini-css-extract-plugin
module.exports = {"headlineButtonWrapper":"HeadlinesButton_headlineButtonWrapper__3Ek4G","headlineButton":"HeadlinesButton_headlineButton__1MCei"};